export default __webpack_public_path__ + "static/media/sip_abacus_logo.af759128.png";